<template>
  <div id="pageCourseList" class="container" vocab="http://schema.org/">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Cursos disponíveis</h2>
        </v-flex>
        <v-flex xs12 sm6 lg4 xl3 v-for="course in courses" :key="course.id">
          <v-skeleton-loader
            :loading="loading"
            transition="scale-transition"
            height="320"
            type="card"
          >
            <ShoppingCard
              :courseId="course.id"
              :courseName="course.course"
              :image="course.background_image"
              :description="course.description"
              :price="course.price"
              :anchor="course.price_anchor"
              @card-clicked="createOrder(course.id)"
            ></ShoppingCard>
          </v-skeleton-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import OrdersService from "../../services/orders.service";
import CoursesService from "../../services/courses.service";
import SharkAffiliate from "../../util/shark-affiliate";
import ShoppingCard from "./ShoppingCard.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    ShoppingCard,
  },
  data() {
    return {
      loading: true,
      message: "Por favor, aguarde...",
      courses: [{}, {}, {}, {}],
      // paypal: CONFIG.PAYPAL_CREDENTIALS
    };
  },
  mounted() {
    if (this.$route.query.sku) this.createOrder(this.$route.query.sku);
    this.loadCourses();
    this.checkCoupon();
  },
  computed: mapGetters({
    user: "authUser",
    authenticated: "authCheck",
  }),
  methods: {
    loadCourses() {
      this.loading = true;
      CoursesService.getListPublic({ orderBy: "price", sortedBy: "desc" })
        .then((response) => {
          this.courses = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    createOrder(courseId) {
      this.loading = true;
      let affiliateRef = SharkAffiliate.getAffiliateRefFromCookie();
      console.log("criando pedido", affiliateRef);
      const utm_source = Cookies.get("utm_source") || null;
      const utm_medium = Cookies.get("utm_medium") || null;
      const utm_campaign = Cookies.get("utm_campaign") || null;
      const utm_id = Cookies.get("utm_id") || null;

      let query = { course: courseId };
      if (this.$route.query.coupon) query.coupon = this.$route.query.coupon;

      OrdersService.createOrder(courseId, affiliateRef, {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_id: utm_id,
      })
        .then((resp) => {
          this.$router.push({
            name: "checkout",
            params: { orderId: resp.data.id },
            query: query,
          });
        })
        .catch((err) => {
          window.getApp.sendSnackMessage(err.message, "error");
          this.loading = false;
        });
    },
    checkCoupon() {
      if (this.$route.query.coupon) {
        this.loading = true;
        OrdersService.checkCoupon(this.$route.query.coupon)
          .then((resp) => {
            window.getApp.sendSnackMessage(
              `Cupom aplicado! O desconto será exibido na próxima etapa do checkout.`,
              "success",
            );
          })
          .catch((err) => {
            window.getApp.sendSnackMessage(`Cupom inválido!`, "error");
          });
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
